import React from 'react';
import PaginationItem from '@mui/material/PaginationItem';
import MUIPagination, { PaginationRenderItemParams } from '@mui/material/Pagination';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

export interface PaginationProps {
  total: number;
  offset: number;
  onHandlePagination: (selectedPage: number)=> void;
}

const Pagination = ({
  total,
  offset,
  onHandlePagination,
}: PaginationProps) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <MUIPagination
        count={ total }
        size="medium"
        page={ offset }
        variant="outlined"
        shape="circular"
        data-testid="pagination-id"
        renderItem={ (params:PaginationRenderItemParams) => (
          <PaginationItem
            sx={{
              fontSize: '14px',
              border: params.type !== 'page' ? undefined : 'none',
              color: ((!params.selected && params.type === 'page') || params.type.includes('ellipsis')) ? theme.palette.grey[500] : undefined,
              background: params.selected ? 'none !important' : undefined,
            }}
            { ...params } />
        ) }
        onChange={ (
          _e: React.ChangeEvent<unknown>,
          page: number,
        ) => onHandlePagination(page) } />
    </Box>
  );
};

export default Pagination;
